export default "__VITE_ASSET__f4942637__"